import { render, staticRenderFns } from "./sprints.vue?vue&type=template&id=56913e48"
import script from "./sprints.vue?vue&type=script&lang=js"
export * from "./sprints.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./sprints.vue?vue&type=style&index=1&id=56913e48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports